import React, { useState, useEffect } from 'react';
import { CheckBoxes } from '../sub-component';
import axios from 'axios';
import { IGenreProps } from './genre.types';

// const API = `https://epidemic-plugin-dot-ssemble-plugins-backend.uc.r.appspot.com`;

const API = `https://plugin-epidemic-api.ssemble.com`;

export const Genre = (props: IGenreProps) => {
  const { setSelectedFilter, filter, previousFilter, setPreviousFilter } = props;

  const [loading, setLoading] = useState(true);
  const [data, setData]: any = useState([]);
  const [count, setCount] = useState(0);
  const [isCheckBoxes, setCheckboxes]: any[] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!filter) {
        setSelectedFilter('hip-hop');
      }
      try {
        const { data: response } = await axios.get(`${API}/filter`);
        setData(response.parameter.genres);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
    if (count === 0) {
      setCount(1);
      fetchData();
    }
  }, [count, filter, setSelectedFilter]);

  useEffect(() => {
    const GetCheckBoxes = () => {
      const elements = [];
      for (const ele of data) {
        elements.push(<CheckBoxes key={ele.id} setSelectedFilter={setSelectedFilter} filter={filter} value={ele} />);
      }
      return elements;
    }

    if (!isCheckBoxes || isCheckBoxes.length === 0 || previousFilter !== filter) {
      let checkboxes = GetCheckBoxes();
      setCheckboxes(checkboxes);
      setPreviousFilter(filter);
    }
  }, [data, filter, setSelectedFilter, previousFilter]);

  return (
    <div className='display-100-filter scbar' style={{ display: 'none' }}>
      {loading === false ? isCheckBoxes : <div></div>}
    </div>
  );
};